package org.ksdfv.thelema.kxjs

import org.ksdfv.thelema.data.DATA
import org.ksdfv.thelema.data.IByteData
import org.ksdfv.thelema.gl.GL_RGBA
import org.ksdfv.thelema.gl.GL_UNSIGNED_BYTE
import org.ksdfv.thelema.img.IImageData
import org.w3c.dom.HTMLImageElement

/** @author zeganstyl */
class HtmlImage(
    val htmlImage: HTMLImageElement
): IImageData {
    override val sourceObject: Any
        get() = htmlImage

    override var uri: String
        get() = htmlImage.src
        set(value) {
            htmlImage.src = value
        }

    override var width: Int
        get() = htmlImage.width
        set(value) { htmlImage.width = value }

    override var height: Int
        get() = htmlImage.height
        set(value) { htmlImage.height = value }

    override var bytes: IByteData
        get() = DATA.nullBuffer
        set(_) {}

    override var glInternalFormat: Int
        get() = GL_RGBA
        set(_) {}

    override var glPixelFormat: Int
        get() = GL_RGBA
        set(_) {}

    override var glType: Int
        get() = GL_UNSIGNED_BYTE
        set(_) {}

    override var name: String = ""

    override fun destroy() {
        val htmlImage = htmlImage
        htmlImage.parentNode?.removeChild(htmlImage)
    }
}